/**
 * Compose the human-facing build version label shown in the footer / build badge.
 * Shape: `date · tag · sha`, joined with `-`, with empty parts dropped — so an
 * untagged build collapses to `2026.06.16-6b4318f` while a tagged release reads
 * `2026.06.16-v0.40-alpha-6b4318f`.
 */
export function formatBuildVersion(input: {
  sha: string;
  builtAt: string;
  tag: string;
}): string {
  const datePart = input.builtAt ? input.builtAt.slice(0, 10).replaceAll('-', '.') : '';
  const shortSha = input.sha ? input.sha.slice(0, 7) : '';
  return [datePart, input.tag, shortSha].filter(Boolean).join('-');
}
